/* RESPONSIBLE TEAM: team-fin-qa */
import ApplicationAdapter from '../application';

export default class TriggerableProcedureAdapter extends ApplicationAdapter {
  namespace = '';

  pathForType(): string {
    return 'ember/inbox/conversations/qa_monitor_published_procedures';
  }
}
